import * as Globals from "../../globals";
import {buildingGroup, mousePosition, tmpGroup} from "../../main";
import {Mesh, PlaneGeometry, Vector3} from "three";
import {previewMaterial} from "../../constants/materialConstants";
import {setObjectLayer} from "../../utils/layerUtils";
import {nearestAxisCoordinate, snapPointToGridCorners, SNAP_AXIS_TOLERANCE} from "../../utils/snappingUtils";
import {findChildrenByName} from "../../utils/threeUtils";
import {raehmMeshName, supportBeamMeshName} from "../../constants/nameConstants";
import {addVisualAxis, removeVisualAxis} from "../../utils/visualAxisUtils";
import {wallDirectionAxis, wallSnapAxis} from "../walls/wallGeneration";

const gridSnapTolerance = 0.045;
const wallSnapTolerance = 0.05;
const closeWallSnapTolerance = 0.075;
const wallRaycastTolerance = 0.001;
export const previewYPosition = 4;

export class PillarPreview {
    constructor(width, depth, height) {
        this.width = width;
        this.depth = depth;
        this.height = height;

        this.allRaehmMeshes = findChildrenByName(buildingGroup, raehmMeshName, false, true);
        this.supportBeamMeshes = findChildrenByName(buildingGroup, supportBeamMeshName, false, true);
        this.allMeshes = this.allRaehmMeshes.concat(this.supportBeamMeshes);

        this.createPreview();
    }

    createPreview() {
        this.previewMesh = this.createPreviewMesh();
        this.adjustPreview();
        tmpGroup.addWithUuid(this.previewMesh);
    }

    createPreviewMesh() {
        //Generiere Vorschau für ersten Wandklick
        let geometry = new PlaneGeometry(this.width, this.depth);
        geometry.rotateX(Math.PI / 2); //Rotieren um auf x/z zu liegen
        let previewMesh = new Mesh(geometry, previewMaterial);
        previewMesh.name = "pillarPreview";
        setObjectLayer(previewMesh, Globals.layers.layoutViewOnly);
        return previewMesh;
    }

    adjustPreview() {
        let snapPoint = this.snapPreview();
        if (snapPoint === null) {
            snapPoint = mousePosition;
        }
        this.previewMesh.position.copy(snapPoint);
        this.previewMesh.position.y = previewYPosition;
    }

    snapPreview() {
        //Snap an bestehende Wände probieren
        /*let wallPosition = snapPointToClosestWallBoundary(mousePosition, this.allMeshes, 0.5 * this.width);
        if (wallPosition !== null) {
            if (wallPosition.distanceTo(mousePosition) <= wallSnapTolerance) {
                return wallPosition;
            }
        }*/

        let axisPosition = this.snapPointToAxis(mousePosition);
        if (axisPosition !== null) {
            return axisPosition;
        }


        //Snap an Grid probieren, sofern keine Wand gefunden oder die Toleranz zur Wand überschritten wurde.
        let gridPosition = snapPointToGridCorners(mousePosition, this.width, this.depth); //Position am nächsten Rasterpunkt
        if (gridPosition.distanceTo(mousePosition) <= gridSnapTolerance) {
            return gridPosition;
        }

        return null; //Wenn weder noch zutrifft null zurückgeben. Kein Snappoint konnte berechnet werden. Wird anschließend an Mausposition gesetzt
    }

    snapPointToAxis(point) {

        removeVisualAxis();
        let closestPoint = null;
        if (wallSnapAxis.z.length > 0) {
            closestPoint = this.snapPointToSingleAxis(point, wallSnapAxis.z, "x", this.width * 0.5);
        }
        if (wallSnapAxis.x.length > 0) {
            let tmpClosestPoint = null;
            if (closestPoint !== null) {
                tmpClosestPoint = this.snapPointToSingleAxis(closestPoint, wallSnapAxis.x, "z", this.width * 0.5);
            } else {
                tmpClosestPoint = this.snapPointToSingleAxis(point, wallSnapAxis.x, "z", this.width * 0.5);
            }

            if (tmpClosestPoint !== null) {
                closestPoint = tmpClosestPoint;
            }
        }

        return closestPoint;
    }

    snapPointToSingleAxis(point, lines, direction, offset) {
        if (point === null || point === undefined) {
            return null;
        }

        const nearest = nearestAxisCoordinate(point, lines, direction, SNAP_AXIS_TOLERANCE);
        if (nearest === null) {
            return null;
        }

        const closestPoint = new Vector3().copy(point);
        if (direction === "x") {
            closestPoint.x = nearest.coord;
            addVisualAxis(closestPoint, wallDirectionAxis.xAxis);
            closestPoint.x += point.x > nearest.coord ? offset : -offset;
        } else {
            closestPoint.z = nearest.coord;
            addVisualAxis(closestPoint, wallDirectionAxis.zAxis);
            closestPoint.z += point.z > nearest.coord ? offset : -offset;
        }
        closestPoint.y = 4;
        return closestPoint;
    }
}
